import React, { createContext, useContext, useMemo, useReducer, useEffect, useState, useCallback } from 'react';
import AxiosService from "../../services/axios.service";
//import { useDetectScroll } from "@smakss/react-scroll-direction";
import useScrollDirection from "../../hooks/useScrollDirection";
import { useRemember, router } from '@inertiajs/react'
import { createBrowserHistory } from 'history';
import useWindowSize from '../../hooks/useWindowSize';
import { useLocation } from 'react-router';
import useWindowHeight from '../../hooks/useWindowHeight';
import Logins from '../../Components/sessions/Logins';
import { BlobOptions } from 'buffer';
import { filter, keyBy } from 'lodash';
import { useAppContext } from "./AppContext";

const history = createBrowserHistory();
const CategoryPageContext = createContext(null);
//const { setFooterVisible } = useAppContext();

function getTermFromURL(url) {
  const searchParams = new URLSearchParams(url.split('?')[1])
  return searchParams.get('term') || ''
}

export const CategoryPageProvider: React.memo = ({ children, data }) => {




  const url = getTermFromURL(window.location.href)
  const [cachePage, setCachePage] = useRemember({ page: data.currentPage, scroll: 0, productVisit: null, products: null, pagesLoaded: null, pagesP: {}, filters: [], hasMore:data?.lastPage <= 1 ? false : true });
  const [categoryProducts, setCategoryProducts] = useState(cachePage['products'] ? cachePage['products'] : data.products?.data ? data.products.data : data.results?.data)
  const [totalPages, setTotalPages] = useState(data.lastPage);
  const [currentPage, setCurrentPage] = useState(cachePage['page'] ? cachePage['page'] : data.currentPage);
  const [pagePath, setPagePath] = useState(data.path);
  //const [hasMore, setHasMore] = useState(true);
  //const [hasMore, setHasMore] = useState(data?.lastPage <= 1 ? false : true);
  const [hasMore, setHasMore] = useState(cachePage['hasMore']);
  const scrollDir = useScrollDirection();
  const [pagesHasLoaded, setPagesHasLoaded] = useState(cachePage['pagesLoaded'] ? cachePage['pagesLoaded'] : [data.currentPage]);//useState(cachePage['page'] ? [cachePage['page']] : [data.currentPage]);
  const [init, setInit] = useState(true);
  const [loadMore, setLoadMore] = useState(true)
  const [productPages, setProductPages] = useState(cachePage['pagesP'] ? cachePage['pagesP'] : null)
  const [topProduct, setTopProduct] = useState(null)
  const [pageY, setPageY] = useState(cachePage['scroll'])
  const [filters, setFilters] = useState(cachePage['filters'] ? cachePage['filters'] : [])
  const [params, setParams] = useState(null)
  //const [threshold, setThreshold] = useState(useWindowHeight() * 4)
  const [threshold, setThreshold] = useState(300)
  const { imgsLoaded } = useAppContext()

  //console.log('tgres => ', useWindowHeight() * 3)

  const [categoryId, setCategoryId] = useState(data.category)
  const [categoryName, setCategoryName] = useState(data.categoryName)
  const [scrollPosition, setScrollPosition] = useState(0)
  const [isSearch, setIsSearch] = useState(data?.search)

  const [productsResponse, setProductsResponse] = useState([])
  const [right, setRight] = useState(true)
  const [filterApply, setFilterApply] = useState(false);

  const screenWidth = useWindowSize()


  const addFilter = useCallback((code: string, filter: string) => {

    let filtersTemp = filters;

    if (!filtersTemp[code]) {
      filtersTemp[code] = []
    }


    if (code == 'price') {
      setFilterApply(true)
      filtersTemp['price'] = filter

    } else if (code == 'sort') {

      filtersTemp[code] = [];
      if (!filtersTemp['order']) {
        filtersTemp['order'] = []
      }
      filtersTemp['order'] = [];
      filtersTemp[code].push(filter.split(',')[0]);
      filtersTemp['order'].push(filter.split(',')[1]);

    } else {

      if (filtersTemp[code].indexOf(filter) != -1) {
        const index = filtersTemp[code].findIndex((f: any) => f === filter);
        filtersTemp[code].splice(index, 1);
      } else {
        filtersTemp[code].push(filter)
      }

    }
    
    setFilters(filtersTemp)
    applyFilters()


  }, [])

  async function applyFilters(runQuery = true, iniit = true) {

    //setFilterApply(true)
   
    let params = [];
    let findSortKey = false;
    for (let key in filters) {

      //findSortKey = (key == 'sort');

      if (key != 'page' && filters[key].length) {

        params.push(key + '=' + filters[key].join(','));

      }

    }

    /*if (!findSortKey) {

      params.push('sort=created_at')
      params.push('order=desc')
    }*/

    setParams(params.join('&'));

    if (!runQuery) {
      return;
    }

    /*if (!loadMore) {
       return;
    }*/
   
    let products = []
    
    if(iniit){
      if (!isSearch) {
        products = await AxiosService.get('/api/category-products/' + pagePath + "?" + params.join('&'))
  
      } else {
  
        
        products = await AxiosService.get('/search?category=&term=' + url + "&" + params.join('&'))
      }
    }




    //let products = await AxiosService.get('/api/category-products/' + pagePath + "?" + params.join('&'))


    // console.log('apply filters called');
    // console.log(products.data.products);

if(iniit){
  setPageY(0);
  setTopProduct(categoryProducts[0]?.id || null)
  //setCategoryProducts(products.data.products)
  setProductsResponse(products?.data.products)
  setCurrentPage(products?.data?.currentPage);
  setPagesHasLoaded([products?.data?.currentPage]);
  //setHasMore(data?.lastPage <= 1 || products.data.products.length == 0 ? false : true)
  setHasMore(products?.data?.lastPage <= 1 || products.data.products.length == 0 ? false : true)
  setTotalPages(products?.data?.lastPage);
}else{
  
  setProductsResponse(cachePage['products'] ? cachePage['products'] : data.products?.data ? data.products.data : data.results?.data)
  setHasMore(cachePage['hasMore']);
}
   
    //setLoadMore(true)

  }


  useEffect(() => {

    if (filterApply) {
      document.body.style.overflow = 'hidden';
      document.body.style.height = "100vh"

    } else {
      document.body.style.overflow = 'unset';
      document.body.style.height = 'unset';

    }

  }, [filterApply])

  useEffect(() => {
    // declare the data fetching function

    let hasFilters = false;

    for (let key in filters) {
      if(!hasFilters){
        hasFilters = filters[key].length;
      }
    }

    if (localStorage.getItem('login') && localStorage.getItem('login') === '1') {
      localStorage.removeItem('login')
      setFilterApply(true);
      applyFilters();
    }else if(hasFilters){
      setFilterApply(true);
      applyFilters(true,false);
    }

  }, [])

  useEffect(() => {
   

    if (filterApply) {

      //console.log('ede1')
      setCategoryProducts(productsResponse);
      setFilterApply(false)

    }
    else if (right) {
      //console.log('ede2')
      setCategoryProducts([...categoryProducts, ...productsResponse])

    } else {
      //console.log('ede3')
      //setCategoryProducts([...productsResponse, ...categoryProducts,])
      setCategoryProducts([...categoryProducts, ...productsResponse])
    }
    setLoadMore(true)
 
  }, [productsResponse])

  useEffect(() => {

    
    
      //if(!filterApply){

        //setTimeout(() => {
          window.requestAnimationFrame(scrollTo)
        //}, 1);

       

     //}
    

  }, [categoryProducts]) //screenWidth [imgsLoaded, filterApply] categoryProducts


  useEffect(() => {

    if (pagesHasLoaded.indexOf(currentPage) != -1) {
      return
    }

    setPagesHasLoaded([...pagesHasLoaded, currentPage])
    //console.log('has loaded => ', pagesHasLoaded)

  }, [currentPage])


  useEffect(() => {


    setCachePage({
      page: currentPage,
      scroll: pageY,
      productVisit: topProduct,
      products: categoryProducts,
      pagesLoaded: pagesHasLoaded,
      pagesP: productPages,
      filters: filters,
      hasMore:hasMore
    });

  }, [currentPage, categoryProducts, pagesHasLoaded, productPages, topProduct,hasMore]) //,filters

  const contextValue = useMemo(() => {

    setInit(false);
    return {
      categoryProducts, hasMore, loading,
      scrollDir, handleOnWheel, handleClick, addFilter, filters, setFilters, threshold, categoryId, categoryName, isSearch, setLoadMore, loadMore, filterApply, setFilterApply
    }

  }, [categoryProducts, scrollDir, pageY, hasMore, loadMore, filterApply])


  function handleOnWheel(event: {
    stopPropagation(): unknown;
    type: string;
    changedTouches: any; pageY: React.SetStateAction<number>; currentTarget: any;
  }) {

    //event.preventDefault()
    event.stopPropagation()

    if (event.pageY > 0) {
      setPageY(event.pageY)
    }

    let currentTarget = event.currentTarget

    if (productPages[currentTarget.id]) {
      setCurrentPage(productPages[currentTarget.id])

    }
  }


  async function loading() {

    if (!loadMore) {
      return;
    }
    setLoadMore(false);
    //check if scroll up to previous page
    let current_page = await getThePage();
    setHasMore(!(currentPage == totalPages))

    if (pagesHasLoaded.indexOf(current_page) != -1) {
      setLoadMore(true);
      return;
    }

    setPagesHasLoaded([...pagesHasLoaded, current_page])
    let products = []
    if (!isSearch) {
      products = await AxiosService.get('/api/category-products/' + pagePath + "?page=" + current_page + "&" + params)
    } else {
      products = await AxiosService.get('/search?category=&term=' + url + "&page=" + current_page + "&" + params)

    }


    if (products?.data?.products?.length > 0) {
     
      localStorage.removeItem('ID');

      if (current_page < currentPage) {
        setTopProduct(categoryProducts[0].id)
        if (products.data.products.length) {
          setProductsResponse(products.data.products)
          setRight(true)
        }
      } else {
        if (products.data.products.length) {
          setProductsResponse(products.data.products)
          //setCategoryProducts([...categoryProducts, ...products.data.products])
          setRight(false)
        }
      }
    }
  }

  async function scrollTo() {

    const myIDstring = localStorage.getItem('ID')
    //localStorage.removeItem('ID');
    let element = myIDstring ? document.getElementById(myIDstring) : null

    history.scrollRestoration = "manual";

    if (element) {
      
      /*console.log('edw')
      console.log('myIDstring => ', myIDstring)
      console.log('element => ', element)
      console.log('history.scrollRestoration => ', history.scrollRestoration)
      console.log('products count => ', categoryProducts.length)
      console.log('########');*/

      //element?.scrollIntoView({ behavior: 'auto', block: "center"});//to diko mas

      /*element?.scrollIntoView({ 
        block: "nearest",
        inline: "center",
        behavior: "auto",
        alignToTop: false
      });*/

      element?.scrollIntoView({ 
        block: "center",
        inline: "center",
        behavior: "auto",
        alignToTop: false
      });
      //localStorage.removeItem('ID');
      //element.scrollIntoView({ block: "nearest", behavior: 'smooth' });
      
      setTopProduct(null)
    }

  }

  async function getThePage() {
    let current_page = currentPage;
    if ((currentPage + 1) <= totalPages) {
      //check if i have to fetch products from previous page
      if (scrollDir == 'up' && !init) {

        current_page = currentPage - 1 > 1 ? currentPage - 1 : 1

        if (pagesHasLoaded.indexOf(current_page) != -1) {
          current_page = Math.min(...pagesHasLoaded) - 1;
          if (current_page < 1) {
            current_page = 1;
          }
        }

      } else if (!init) {
        current_page = currentPage + 1;

        if (pagesHasLoaded.indexOf(current_page) != -1) {
          current_page = Math.max(...pagesHasLoaded) + 1
        }
      }
    }

    setCurrentPage(current_page)
    return current_page;

  }

  function handleClick(e: any, url: any, pageNumber: int) {

    const myId = e;
    //console.log('click id => ', myId);
    localStorage.setItem('ID', JSON.stringify(myId));
    localStorage.setItem('pageNumber', JSON.stringify(pageNumber));

    let page = cachePage['page']
    let scroll = pageY

    //setCachePage({ page: page, scroll: scroll, productVisit: e, products: categoryProducts, pagesLoaded: cachePage['pagesLoaded'], pagesP: cachePage['pagesP'], filters: cachePage['filters'] })

  }

  return (
    <CategoryPageContext.Provider value={contextValue}>
      {/* <ContextDevTool context={AppContext} id="app-context" displayName="App" /> */}
      {children}
    </CategoryPageContext.Provider>
  )

}

export const useCategoryPageContext = () =>

  useContext<{
    categoryProducts: any,
    totalPages: any,
    currentPage: any,
    hasMore: any,
    loading(),
    scrollDir: any,
    productPages: any,
    loadMore: any,
    setCachePage: any,
    cachePage: any,
    handleOnWheel: any,
    pageY: any,
    handleClick(),
    addFilter(),
    filters: any,
    setFilters: any,
    threshold: any,
    categoryId: any,
    categoryName: any,
    activeFilters: any,
    setActiveFilters: any,
    isSearch: boolean,
    setLoadMore: any,
    filterApply: boolean,
    setFilterApply: any
  }>(CategoryPageContext)

export default CategoryPageContext